<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <h4 class="page-title">Assessment Criteria Percentage</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-4">
              <!-- advance serach -->
              <div class="d-flex">
                <div class="d-flex flex-column me-2">
                  <label class="col-form-label">Program</label>
                  <div style="width: 250px">
                    <v-select
                      label="name"
                      v-model="program"
                      :options="programList"
                      :clearable="false"
                      :selectable="(options) => program.id != options.id"
                      @option:selected="FilterData(program, level, type)"
                    >
                    </v-select>
                  </div>
                </div>
                <div class="d-flex flex-column me-2">
                  <label class="col-form-label">Level</label>
                  <div style="width: 180px">
                    <v-select
                      label="name"
                      v-model="level"
                      :options="getLevel"
                      :clearable="false"
                      :selectable="(options) => level.id != options.id"
                      @option:selected="FilterData(program, level, type)"
                    >
                    </v-select>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <label class="col-form-label">Type</label>
                  <div style="width: 170px">
                    <v-select
                      label="name"
                      v-model="type"
                      :options="getType"
                      :clearable="false"
                      :reduce="(val) => val.name"
                      :selectable="(options) => type != options.name"
                      @option:selected="FilterData(program, level, type)"
                    >
                    </v-select>
                  </div>
                </div>
                <div class="d-flex mt-4">
                  <!-- <div class="col-form-label d-none">hfhd</div> -->
                  <div @click="refreshData()" class="icon-css">
                    <i style="color: #4a81d4" class="fe-rotate-cw"></i>
                  </div>
                </div>
              </div>
              <!--end advance serach -->
              <div class="d-flex justify-content-end mb-3">
                <router-link
                  :to="{ name: 'assessment-criteria-percentage-create' }"
                >
                  <button
                    v-show="!isLoading"
                    type="button"
                    class="btn btn-sm btn-blue waves-effect waves-light"
                  >
                    <i class="mdi mdi-plus-circle"></i> Add Criteria
                  </button>
                </router-link>
              </div>
              <place-holder v-if="isLoading"></place-holder>

              <DataTable
                v-else
                table="dataTable"
                :data="criteria"
                :columns="column"
                route="assessment-criteria-percentage-edit"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
name
<script>
import DataTable from "../../../components/shared/DataTable.vue";
import axios from "axios";
import $ from "jquery";
import { levels } from "../../../const";
import { types } from "../../../const";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

// import { render } from 'vue';
export default {
  components: { DataTable, vSelect },

  data() {
    return {
      isLoading: true,
      number: 0,
      criteria: [],
      programList: this.$store.getters["odoo/getAllPrograms"],
      getLevel: levels,
      getType: types,
      type: "",
      level: "",
      program: "",
      baseUrl: process.env.VUE_APP_BASE_URL,

      column: [
        {
          data: "id",
          title: "No",
          render: () => {
            this.number++;
            return this.number;
          },
        },
        { data: "code", title: "ID" },
        {
          data: "programs",
          title: "Programs",
          render: (data) => {
            let str = "";
            for (let val of data) {
              str += val.code + ", ";
              // return val.code;
            }
            return str.slice(0, -2);
          },
        },
        { data: "level", title: "Level" },
        { data: "type", title: "Type" },
        {
          data: "percentage",
          title: "Percentage",
          render: (data) => {
            return `${data}%`;
          }
        },
        {
          data: null,
          title: "Action",
          render: () => {
            return `<i class="mdi mdi-square-edit-outline edit-icon hover fs-4"></i>`;
          },
        },
      ],
    };
  },

  methods: {
    async getAllCriteria() {
      await axios
        .get(`${this.baseUrl}admin/v2/assessment-criteria-percentage`)
        .then((res) => {
          this.criteria = res.data.data;
          this.isLoading = false;
          $("#dataTable").DataTable().draw();
        })
        .catch(() => this.toast.error("Something Went Wrong!"));
    },

    clearFilter() {
      $.fn.dataTable.ext.search.pop();
      $("#dataTable").DataTable().destroy();
      $("#dataTable").DataTable().draw();
    },

    refreshData() {
      this.clearFilter();
      this.level = "";
      this.type = "";
      this.criteria = [];
      this.program = "";

      this.getAllCriteria();
      this.number = 0;
    },

    FilterData(program, level, type) {
      this.clearFilter();
      $.fn.dataTable.ext.search.push(function (settings, data) {
        const check_level = level?.name == data[3] ? true : false;
        const check_program = data[2].includes(program?.short_name)
          ? true
          : false;
        const check_type = type == data[4] ? true : false;

        if (
          (check_level || !level.name) &&
          (check_type || !type) &&
          (check_program || !program.short_name)
        ) {
          return true;
        }

        return false;
      });

      $("#dataTable").DataTable().draw();
    },
  },

  async created() {
    await this.getAllCriteria();
  },
};
</script>
